<template>
  <div class="content">
    <div style="font-size: 13.5px;" >{{ items.length > 0 ? $i18n.t("ppt_add_in_main.txt_title_enchance_prompt_list") : '抱歉，Prompt优化失败' }}</div>
    <ul>
      <li v-for="(item, index) in items" :key="index" :class="{ selected: selectedIndex === index }"
        @mouseenter="hoverIndex = index"
        @mouseleave="hoverIndex = null"
        @click="selectItem(index)">
        <div style="display: flex;">
          <!-- <div style="width: auto; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" v-if="index === 0">
            原本:
          </div>
          <div style="width: auto; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" v-if="index === 1">
            建议1:
          </div>
          <div style="width: auto; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" v-if="index === 2">
            建议2:
          </div>
          <div style="width: auto; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" v-if="index === 3">
            建议3:
          </div> -->
          <div class="item-header">
            {{ item.Title }}
          </div>
          <!-- show detail -->
          <div v-show="hoverIndex === index" style="display: flex; gap: 8px; margin-left: 5px; ">
              <v-icon size="17" @click.stop="toggleDetail(index)">
                {{ showDetailIndex === index ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
              </v-icon>
          </div>
          <!-- selected -->
          <v-icon size="17" v-if="selectedIndex === index" style="align-items: end; margin-left: 5px; "> mdi-check </v-icon>
        </div>
        <!-- detail -->
        <div v-if="showDetailIndex === index" class="item-detail">
          <p>{{ item.Prompt }}</p>
          <!-- <button @click.stop="openEditModal(index)">编辑</button> -->
        </div>
      </li>
    </ul>
    <!-- confirm -->
    <div v-if="items.length > 0" style="display: flex; justify-content: end; align-items: center;">
      <div style="font-size: 13px; color:cadetblue; " > {{ $i18n.t("ppt_add_in_main.txt_remiind_enchance_prompt_confirm") }} </div>
      <v-chip color="primary" dark outlined label @click="confirmSelection" style="height: 22px; font-size: 13px;">
        <v-icon left size="14"> mdi-arrow-up </v-icon>
        {{ $i18n.t("ppt_add_in_main.confirm") }}
      </v-chip>
    </div>
    <!-- 编辑弹框 -->
    <div v-if="isEditModalOpen" class="modal">
      <div class="modal-content">
        <h2>编辑详情</h2>
        <textarea v-model="editedDetail"></textarea>
        <button @click="saveEdit">保存</button>
        <button @click="closeEditModal">关闭</button>
      </div>
    </div>
  </div>
</template>
  
  <script>
  export default {
    props: {
      items: {
        type: Array,
        required: true,
      },
      // title: {
      //   type: String,
      //   default: "我的列表",
      // },
    },
    data() {
      return {
        selectedIndex: null,
        showDetailIndex: null,
        hoverIndex: null, // 当前悬浮的 item 索引
        isEditModalOpen: false,
        editedDetail: "",
        editingIndex: null,
      };
    },
    mounted() {
      // 默认选中第一个项
      if (this.items.length > 0) {
        this.selectedIndex = 0;
      }
    },
    methods: {
      selectItem(index) {
        this.selectedIndex = index;
      },
      toggleDetail(index) {
        this.showDetailIndex = this.showDetailIndex === index ? null : index;
        this.$emit("showDetail");
      },
      openEditModal(index) {
        this.editingIndex = index;
        this.editedDetail = this.items[index].Prompt;
        this.isEditModalOpen = true;
      },
      closeEditModal() {
        this.isEditModalOpen = false;
      },
      saveEdit() {
        if (this.editingIndex !== null) {
          this.$set(this.items, this.editingIndex, {
            ...this.items[this.editingIndex],
            Prompt: this.editedDetail,
          });
        }
        this.closeEditModal();
      },
      confirmSelection() {
        if (this.selectedIndex !== null) {
          const selectedItem = this.items[this.selectedIndex];
          this.$emit("confirm", selectedItem);
        } else {
          alert("Pls select an item first");
        }
      },
    },
  };
  </script>
  
  <style scoped>
  .content {
    border: none;
    margin: 0 auto;
    height: auto;
    padding-bottom: 8px;
    /* padding: 20px; */
    /* text-align: center; */
  }

  ul {
    list-style-type: none;
    padding: 0;
  }
  
  li {
    margin: 6px 0;
    padding: 5px 5px;
    border: 1px solid #ccc;
    cursor: pointer;
  }
  
  li.selected {
    background-color: #e0f7fa;
  }
  
  .item-header {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: flex;
    width: 100%;
    font-size: 13.5px;
  }
  
  .item-detail {
    background-color: rgb(251, 255, 242);
    font-size: 14px;
    margin-top: 3px;
    padding: 2px 2px;
  }
  
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .modal-content {
    background-color: white;
    padding: 20px;
    border-radius: 5px;
    width: 300px;
  }
  
  textarea {
    width: 100%;
    height: 100px;
    margin-bottom: 10px;
  }
  </style>